import React, { useEffect, useState } from "react";
import CategoryCard from "../common/cards/CategoryCard";
import { getApi } from "../../services/api";
import HomeLoadingCards from "../common/Loadinganimations/HomeLoadingCards";

function OurCourses() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const categories = await getApi("/courseCategory"); // Sorted by the backend
        setCategories(categories);
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch courses:", error);
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  return (
    <div className="mt-20 mb-28 flex flex-col justify-center items-center w-full">
      <h3 className="text-sm text-mainColor font-medium mb-4">Learn with us</h3>
      <h1 className="md:text-3xl text-xl font-semibold text-center mb-20">
        Our Online Courses Categories
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:mx-0 mx-5">
        {loading
          ? [1, 2, 3, 4].map((_, index) => <HomeLoadingCards key={index} />)
          : categories.map((category) => (
              <CategoryCard key={category._id} category={category} />
            ))}
      </div>
    </div>
  );
}

export default OurCourses;
